export default __webpack_public_path__ + "static/appartementen-desktop-7341e7ab85e8c274327e46e8b94ffbeb.svg";